import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Save = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.173 3.58c0-.608.486-1.1 1.086-1.1h6.519v8.797c0 1.823 1.459 3.3 3.259 3.3H30.42c1.8 0 3.259-1.477 3.259-3.3V2.48h.186c.288 0 .565.115.769.322l6.875 6.96c.204.206.318.485.318.777V40.42c0 .607-.486 1.1-1.086 1.1h-2.716V24.473c0-1.822-1.46-3.299-3.26-3.299H9.778c-1.8 0-3.26 1.477-3.26 3.3V41.52H3.26c-.6 0-1.086-.492-1.086-1.1V3.58Zm9.778 7.697V2.48h19.555v8.797c0 .608-.486 1.1-1.086 1.1H13.037c-.6 0-1.086-.492-1.086-1.1ZM8.69 41.52h27.16V24.474c0-.607-.486-1.1-1.086-1.1H9.778c-.6 0-1.087.493-1.087 1.1V41.52ZM3.26.28C1.46.28 0 1.757 0 3.58v36.84c0 1.823 1.46 3.3 3.26 3.3h37.48c1.8 0 3.26-1.477 3.26-3.3V10.54a3.32 3.32 0 0 0-.955-2.333l-6.875-6.96A3.24 3.24 0 0 0 33.865.28H3.26Zm22.272 3.85c-.3 0-.543.245-.543.549v4.949c0 .304.243.55.543.55h3.802c.3 0 .544-.246.544-.55V4.679a.547.547 0 0 0-.544-.55h-3.802Zm.543 4.948v-3.85h2.716v3.85h-2.716Z"
  }));
});
Save.displayName = 'Save';
Save.defaultProps = {
  'aria-label': 'Save'
};
export default Save;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Save.js
// module id = 3900
// module chunks = 11